import React from 'react';
import './Loading.scss';
import { LIGHT_GREEN } from '../../utils/webColors';
import { CgSpinner } from 'react-icons/cg';

function Loading() {
    return (
        <div className='spinner'>
            <CgSpinner className='spinner_icon' style={{ color: LIGHT_GREEN }} />
        </div>
    )
}

export default Loading;
